import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from '@streamr/tv-ui';
import styled from 'styled-components';
export function OverlayToggle({ checked = false, onChange, }) {
    return (_jsxs(OverlaysToggleRoot, { children: [_jsx(BackdropFilter, {}), _jsxs(Content, { children: [_jsx("strong", { children: "Overlay" }), _jsx(Switch, { checked: checked, onChange: onChange })] })] }));
}
const BackdropFilter = styled.div `
    backdrop-filter: blur(10px);
    position: absolute;
    inset: 0;
`;
const Content = styled.div `
    position: relative;
    height: 2.75rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: var(--tv-ui-color-3);
    padding: 0 0.5rem 0 0.75rem;
    background-color: var(--tv-ui-color-18);

    strong {
        font-weight: 500;
    }
`;
const OverlaysToggleRoot = styled.div `
    border-radius: 1.375rem;
    overflow: hidden;
    position: relative;
    user-select: none;
`;
